import React from 'react';
import { useTranslation } from 'react-i18next';
import { Greeting } from '@cp-mx/common';

export const GreetingUi: React.FC<{ greeting?: Greeting; customerId?: string }> = ({ greeting, customerId }) => {
    const { t } = useTranslation('greeting');
    const greetingText = greeting?.name ? `${t('headline')}, ${greeting.name}` : t('headline');
    const client = `${t('subtitle')} ${customerId} `;
    return (
        <div className="u-mb">
            <h2 className="u-mb-none">{greetingText}</h2>
            <span className="u-text-brand">{client}</span>
        </div>
    );
};
